export interface City {
  city?: string;
  state?: string;
}

export interface Campus extends City {
  id: number;
  name: string;
  address: string;
}

export interface LocationState {
  city?: City;
  availableCities: City[];
  availableCampuses: Campus[];
}

const locationState: LocationState = {
  city: undefined,
  availableCities: [],
  availableCampuses: [],
};

export default locationState;
